import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "youtube",
  "use": "youtube-usage",
  "viewBox": "0 0 20 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 13\" id=\"youtube\"><path d=\"M17.026 0H2.03A2.037 2.037 0 000 2.031v8.938C0 12.086.914 13 2.031 13h14.995a2.037 2.037 0 002.031-2.031V2.03A2.038 2.038 0 0017.026 0zM6.842 9.602V3.398L12.215 6.5 6.842 9.602z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol